<div
  id="header-navigation-bar"
  class="l-container js-menu-contents"
  [ngClass]="{ 'is-drawer-open': isMenuOpen }"
  [attr.aria-hidden]="isAriaHidden"
  style="top: 0; width: 100%"
>
  <!-- ANA Bizログインヘッダー -->
  <ng-container *ngIf="isAnaBizHeader">
    <asw-ana-biz-header (isMenuOpenChange)="changeMenuOpen($event)"></asw-ana-biz-header>
  </ng-container>

  <!-- S03-P030_シートマップ（参照）画面用ヘッダー -->
  <ng-container *ngIf="isInformativeSeatmapHeader">
    <asw-informative-seatmap-header></asw-informative-seatmap-header>
  </ng-container>

  <!-- 標準ヘッダー -->
  <ng-container *ngIf="!isAnaBizHeader && !isInformativeSeatmapHeader">
    <div *ngIf="_common.isNotLogin() || isError">
      <!-- [ログイン前ヘッダー] -->
      <header class="l-header">
        <div class="l-header__main">
          <div class="l-wrap">
            <div class="l-wrap__inner">
              <div class="l-header__wrap">
                <div class="l-header__logo-area">
                  <button aswAllSiteLink id="l-header-notlogin-analogo" style="width: 100%">
                    <img
                      [src]="logoFilePath"
                      [alt]="'alt.headerlogo' | staticMsg"
                      (throttleClick$)="onClickAnaLogo($event)"
                    />
                  </button>
                </div>
                <div class="l-header__sub-area">
                  <ul class="l-header__sub-list u-display-flex-tb">
                    <li class="l-header__sub-item" *ngIf="!isError">
                      <a
                        id="header-plan-review-link-not-login"
                        [href]="planReviewUrl | headerUrl"
                        class="p-drawer-menu-non-member__link"
                        [innerHTML]="'label.all.planDetail' | staticMsg"
                        aswThrottleClick
                        (throttleClick$)="onClickPlanReviewUrl($event)"
                      ></a>
                    </li>
                    <li class="l-header__sub-item" *ngIf="!isError">
                      <a
                        id="header-booking-search-link-not-login"
                        [href]="bookingSearchUrl | headerUrl"
                        class="p-drawer-menu-non-member__link"
                        [innerHTML]="'label.searchReservation' | staticMsg"
                        aswThrottleClick
                        (throttleClick$)="onClickBoolingSearchUrl($event)"
                      ></a>
                    </li>
                    <li class="l-header__sub-item" [innerHTML]="'label.contactinfo' | staticMsg"></li>
                  </ul>
                  <div class="l-header__close u-display-block-sp">
                    <!-- l-header-non-member-drawer-closeが指定できないためasw-buttonは使わない -->
                    <button
                      id="header-non-member-drawer-close-button"
                      class="l-header-non-member-drawer-close js-menu-btn"
                      [attr.aria-label]="'alt.hamburgerMemu' | staticMsg"
                      aria-controls="drawer-menu"
                      attr.aria-expanded="{{ isMenuOpen }}"
                      (click)="clickMenuSpEvent()"
                    >
                      <span></span><span></span><span></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- [ログイン前メニュー] -->
        <div
          id="drawer-menu"
          class="l-header-drawer u-display-block-sp"
          attr.aria-hidden="{{ !isMenuOpen }}"
          (keydown)="tabKeyEvent($event)"
        >
          <div class="l-header-drawer__inner">
            <nav class="l-header-drawer__body">
              <div class="l-header-drawer__menu-area">
                <div class="p-drawer-menu-non-member">
                  <div class="p-drawer-menu-non-member__block">
                    <ul class="p-drawer-menu-non-member__list" *ngIf="!isError">
                      <li class="p-drawer-menu-non-member__item">
                        <a
                          id="header-plan-review-link-not-login-menu"
                          [href]="planReviewUrl | headerUrl"
                          class="p-drawer-menu-non-member__link"
                          [innerHTML]="'label.all.planDetail' | staticMsg"
                          [attr.tabindex]="!isMenuOpen ? '-1' : null"
                          aswThrottleClick
                          (throttleClick$)="onClickPlanReviewUrl($event)"
                        ></a>
                      </li>
                      <li class="p-drawer-menu-non-member__item">
                        <a
                          id="header-booking-search-link-not-login-menu"
                          [href]="bookingSearchUrl | headerUrl"
                          class="p-drawer-menu-non-member__link"
                          [innerHTML]="'label.searchReservation' | staticMsg"
                          [attr.tabindex]="!isMenuOpen ? '-1' : null"
                          aswThrottleClick
                          (throttleClick$)="onClickBoolingSearchUrl($event)"
                        ></a>
                      </li>
                    </ul>
                  </div>
                  <div class="p-drawer-menu-non-member__btn-area">
                    <div
                      class="p-drawer-menu-non-member__help"
                      [innerHTML]="'label.contactinfo' | staticMsg"
                      [ngStyle]="!isMenuOpen ? { display: 'none' } : {}"
                    ></div>
                  </div>
                </div>
              </div>
            </nav>
          </div>
          <div class="l-header-drawer__bg" (click)="closeMenu()"></div>
        </div>

        <!-- //[ログイン前メニュー] -->
      </header>
      <!-- //[ログイン前ヘッダー] -->
    </div>
  </ng-container>
</div>
